import styled from '@emotion/styled'
import { ExternalLink, theme } from 'j-comps'
import { Button } from '@mui/material'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'

const LinkText = styled.span`
  margin-left: ${theme.spacing.medium};
`

const ContentSourcesLink = ({ linkText }) => (
  <ExternalLink
    parentTarget
    href={'https://hootsuite.com/dashboard#/publisher/drafts'}
  >
    <Button>
      <OpenInNewIcon />
      <LinkText>{linkText}</LinkText>
    </Button>
  </ExternalLink>
)

export default ContentSourcesLink
